import DispensaryInfoPage from 'src/dispensary/info';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensaryInfoPage, MainDispensaryLayout);
